import { memo } from 'react';
import { safeFormat } from '@/Domain/utils/safeDate';

type Props = {
  timestamp: string;
};

export const TimestampItem = memo(({ timestamp }: Props) => {
  const formattedDate = safeFormat(timestamp, 'EEEE d, MMMM');
  if (!formattedDate) return null;

  return (
    <li key={timestamp} className="text-foreground-subtle text-sm text-center">
      <span>{formattedDate}</span>
    </li>
  );
});

TimestampItem.displayName = 'TimestampItem';
